// @flow

import React from 'react';
import type { ComponentType } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Search } from '../../form';
import { getPathname } from '../../../store/router/selectors';
import { getFAQResultsQuery } from '../../../store/routes/selectors';
import { fetchRoute } from '../../../store/routes';
import {
  getFaqSearchFieldButtonText,
  getFaqSearchFieldInputPlaceholder,
} from '../../../store/componentSettings/selectors';

type OwnProps = {|
  resultsPage: string, // eslint-disable-line react/no-unused-prop-types
|};

type StateProps = {|
  currentPathname: string, // eslint-disable-line react/no-unused-prop-types
  query: ?string,
  buttonText: string,
  placeholder: string,
|};

type DispatchProps = {|
  redirectWithQuery: (string, string) => void,
|};

type Props = OwnProps & StateProps & DispatchProps;

// @TODO translations: https://justlease.atlassian.net/browse/JUS-899
export const FAQSearch = ({
  currentPathname,
  query,
  redirectWithQuery,
  buttonText,
  placeholder,
}: Props) => (
  <Search
    name="faq-search"
    placeholder={placeholder}
    buttonText={buttonText}
    onSubmit={q => redirectWithQuery(q, currentPathname)}
    defaultValue={query}
  />
);

const mapStateToProps = (state: any): StateProps => ({
  currentPathname: getPathname(state),
  query: getFAQResultsQuery(state),
  buttonText: getFaqSearchFieldButtonText(state),
  placeholder: getFaqSearchFieldInputPlaceholder(state),
});

const mapDispatchToProps = (dispatch: Function, { resultsPage }: OwnProps): DispatchProps => ({
  redirectWithQuery: (query: string, currentPathname: string) => {
    dispatch(
      push({
        pathname: resultsPage,
        search: `?q=${query}`,
        state: {
          preventScrollTop: currentPathname === resultsPage,
        },
      }),
    );
    dispatch(fetchRoute(undefined, true));
  },
});

const SearchContainer: ComponentType<OwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FAQSearch);

export default SearchContainer;
